<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const ReplyIconComment = getIcon("ReplyIconComment");
</script>

{#if typeof ReplyIconComment === 'string'}
	<img src={ReplyIconComment} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof ReplyIconComment === 'function'}
	<svelte:component this={ReplyIconComment} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
